import { radioGroupStyles as s } from "./radio-group.styles.js";
import { FASTRadioGroup as d, radioGroupTemplate as a } from "@matrix42/fast-foundation";
import { RadioGroupOption as n } from "./option/index.js";
const o = class o extends d {
  disabledChanged() {
    super.disabledChanged(), this.$fastController.isConnected && this.updateOptions();
  }
  slottedRadioButtonsChanged(t, e) {
    super.slottedRadioButtonsChanged(t, e), this.updateOptions();
  }
  updateOptions() {
    for (const t of this.slottedRadioButtons)
      t instanceof n && (t.disabled = this.disabled);
  }
};
o.definition = {
  name: "radio-group",
  template: () => a(),
  styles: () => s
};
let i = o;
export {
  i as RadioGroup
};
